// productcat.config.ts
export type SubCategory = {
  id: string;
  name: string;
  checked?: boolean;
};

export const categoryHeader = "Product Categories";

export type MainCategory = {
  id: string;
  name: string;
  isOpen?: boolean;
  subCategories: SubCategory[];
};

export const categoriesData: MainCategory[] = [
  {
    id: "agriculture",
    name: "Agriculture",
    isOpen: false,
    subCategories: [
      { id: "beans", name: "Beans" },
      { id: "fresh-fruit", name: "Fresh Fruit" },
      { id: "grain", name: "Grain" },
      { id: "vegetables", name: "Vegetables" },
      { id: "nuts", name: "Nuts" },
    ],
  },
  {
    id: "beauty",
    name: "Beauty",
    isOpen: false,
    subCategories: [
      { id: "makeup-tools", name: "Makeup Tools" },
      { id: "body-art", name: "Body Art" },
      { id: "skincare", name: "Skincare" },
      { id: "haircare", name: "Hair Care" },
    ],
  },
  {
    id: "apparel",
    name: "Apparel & Accessories",
    isOpen: false,
    subCategories: [
      { id: "clothing", name: "Clothing" },
      { id: "accessories", name: "Accessories" },
      { id: "shoes", name: "Shoes" },
      { id: "bags", name: "Bags" },
    ],
  },
  {
    id: "electronics",
    name: "Consumer Electronics",
    isOpen: false,
    subCategories: [
      { id: "mobile", name: "Mobile Phones" },
      { id: "laptops", name: "Laptops" },
      { id: "cameras", name: "Cameras" },
      { id: "audio", name: "Audio Devices" },
      { id: "wearables", name: "Wearables" },
    ],
  },
];
